<template>
  <div v-if="!inline" class="maplibregl-ctrl maplibregl-ctrl-group MapToolsControl">
    <MapControlTooltip :text="$t('geoportal.mapControls.annotate')">
      <button
        type="button"
        class="MapToolsControl__btn"
        :class="{ 'MapToolsControl__btn--active': isAnnotatePanelOpen }"
        :aria-label="$t('geoportal.mapControls.annotate')"
        @click="toggleAnnotatePanel"
      >
        <Icon icon="material-symbols-light:draw" class="MapToolsControl__icon" />
      </button>
    </MapControlTooltip>
  </div>
  <MapControlTooltip v-else :text="$t('geoportal.mapControls.annotate')">
    <button
      type="button"
      class="MapToolsControl__btn"
      :class="{ 'MapToolsControl__btn--active': isAnnotatePanelOpen }"
      :aria-label="$t('geoportal.mapControls.annotate')"
      @click="toggleAnnotatePanel"
    >
      <Icon icon="material-symbols-light:draw" class="MapToolsControl__icon" />
    </button>
  </MapControlTooltip>
</template>

<script setup lang="ts">
import Icon from '@/components/ui/Icon.vue'
import MapControlTooltip from '@/components/map/controls/MapControlTooltip.vue'
import { useMyMapStore } from '@/stores/myMapStore'
import { computed } from 'vue'

defineProps<{
  inline?: boolean
}>()

const myMapStore = useMyMapStore()

const isAnnotatePanelOpen = computed(
  () => myMapStore.rightSidebarPanelVariant === 'annotate' && myMapStore.rightSidebarPanelUnfolded,
)

function toggleAnnotatePanel() {
  if (isAnnotatePanelOpen.value) {
    myMapStore.rightSidebarPanelUnfolded = false
    return
  }
  myMapStore.rightSidebarPanelVariant = 'annotate'
  myMapStore.activeOsmCategory.rightPanel.active = false
  myMapStore.activeOsmCategory.rightPanel.categoryId = null
  myMapStore.rightSidebarPanelUnfolded = true
}
</script>

<style lang="scss" scoped>
.MapToolsControl__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 29px;
  height: 29px;
  padding: 0;
  border: none;
  border-radius: 0;
  background: white;
  color: var(--color-main);
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f0f0f0;
  }

  &--active {
    background: #f0f0f0;
    color: var(--color-main);
    box-shadow: inset 0 0 0 2px var(--color-main);
  }
}

.MapToolsControl__icon {
  width: 20px;
  height: 20px;
  color: var(--color-main) !important;
}
</style>
